import axios, { AxiosRequestConfig } from 'axios';
import { Toast } from './toast';
import { CommonUtil } from './commonUtil';

let showToast = true;
import RouteUtils from './routeUtils';
import LocalStore from './LocalStore';
import { LoginDOI } from 'src/pages/login/loginApi';

// 需要刷新token 的错误码
const TOKEN_INVALID_CODE = 1;
// 登录异常需要跳回首页的错误码
const LOGIN_INVALID_CODE = [1, 2, 3, 4, 5, 6, 16];
// 不需要弹出信息的 错误码
const NO_MESSAGE_CODE = [0,1,2,3,4,5,6,17,20,24,55,56,57,58,59,60,61,62,63,64,'200'];

axios.defaults.withCredentials = true;

// 添加请求拦截器
axios.interceptors.request.use(
    config => {
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        // 解决IE中请求缓存的问题
        config.headers.common['If-Modified-Since'] = '0';
        config.headers.access_token = userInfo.access_token || '';
        config.headers.OperationPlatform = 'Web';
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);
// 添加响应拦截器
axios.interceptors.response.use(
    response => {
        // console.log('response', response)
        // const { data } = response;
        // if (LOGIN_INVALID_CODE.includes(data.code)) {
        //     if (showToast === true) {
        //         Toast.error(data.message);
        //         RouteUtils.goTo('/login');
        //         changeShowToastStatus(false);
        //     }
        // }else if (data.code !== 0) {
        //     Toast.error(data.message);
        // }
        return response;
    },
    error => {
        // Toast.error('服务异常：' + error.response.status);
        return { data: { code: 100, message: '服务异常：' + error.response.status } };
    },
);

function dealParams(params) {
    let o = {};
    //
    for (let k in params) {
        if (!CommonUtil.isResultEmpty(params[k])) {
            if (CommonUtil.isArray(params[k])) {
                o[k] = params[k].join(',');
            } else {
                o[k] = params[k];
            }
        }
    }
    return o;
}

export function changeShowToastStatus(flag) {
    showToast = flag;
}

export function getFullPath(url: string): string {
    let urls = url.split('/');
    if (urls[0] === '') {
        urls.shift();
    }
    if (urls[0] !== Api.root) {
        urls.unshift(Api.root);
    }
    return '/' + urls.join('/');
    return url;
}

export default class Api {
    static root = 'wqms';

    static async get(url: string, params: Object = {}, config?: AxiosRequestConfig): Promise<any> {
        let res = await axios.get(url, { ...(config || {}), params: dealParams(params) });
        return res.data;
    }

    static async post(url: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
        let res = await axios.post(url, data, config);
        if (res.data.code === TOKEN_INVALID_CODE) {
            let refreshRes = await refresh_token()
            if(!refreshRes) {
                return
            }
            res = await axios.post(url, data, config);
        }
        if(LOGIN_INVALID_CODE.includes(res.data.code)) {
            if (showToast === true) {
                if(!NO_MESSAGE_CODE.includes(res.data.code)){
                    Toast.error(res.data.message);
                }
                changeShowToastStatus(false);
            }
            RouteUtils.goTo('/login');
            return
        } else if(!NO_MESSAGE_CODE.includes(res.data.code)) {
            Toast.error(res.data.message);
        }
        return res.data;
    }
}

let refreshTokenPromise:any = null;
async function refresh_token() {
    let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
    if (!refreshTokenPromise) {
        refreshTokenPromise = axios.post('/auth_verify/refresh_token/refresh', { refresh_token: userInfo.refresh_token });
    }
    let { data: {code, data} } = await refreshTokenPromise;
    refreshTokenPromise = null
    if (code === 0) {
        userInfo = { ...userInfo, ...data };
        LocalStore.setData('userInfo', userInfo);
        return true;
    } else {
        RouteUtils.goTo('/login')
        if(!NO_MESSAGE_CODE.includes(code)) {
            Toast.error(data.message);
        }
        return false;
    }
}
